import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../../../theme/useTheme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  container: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  paginationItemContainer: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  paginationItemInactive: {
    height: 3,
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[300],
  },
  paginationItemActive: {
    backgroundColor: theme.palette.primary[500],
  }
}));
